import {Component} from "react";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import './LogView.css'
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import { Button, ButtonGroup, InputGroup, InputGroupText } from "reactstrap";
import AppRefreshIcon from "../../../media/app-images/AppRefreshIcon.mjs";
import Select from "react-select";
import AppLogIcon from "../../../media/app-images/AppLogIcon.mjs";
import AppAdminIcon from "../../../media/app-images/AppAdminIcon.mjs";
import LogInfoModal from "./LogInfoModal.mjs";


const prefix = "LogView";

/**
 * @typedef LogLine
 * @type {Object}
 * @property {number} id
 * @property {number} logtime
 * @property {string} module
 * @property {string} username
 * @property {number} severity
 * @property {any} logdata
 * @property {string} message
 * @property {string} param
 */

const defaultSizeOptions = [100,250,500,1000,5000].map( x => ({label:String(x), value: x }))

const UsersManagement = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentUser: Glob.getStatus('userLogin'),
			by: Glob.getPageParam('by'),
			page: Glob.getPageParam('page'),
			ll: Glob.getLanguageLong(),
			pageSize: 25,
			sizeOptions: defaultSizeOptions,
			chosenSize: 100,
			moduleOptions: [],
			chosenModule: null,
			usersOptions: [],
			chosenUser: null,
			severityMap: {0: 'info', 1: 'change', 2: 'warning', 3: 'error', 4: 'security'}
		}
		this.uid = Glob.generateUid(prefix);
		this.fetchLogs = this.fetchLogs.bind(this);
		this.sortBy = this.sortBy.bind(this);
		this.sort = this.sort.bind(this);
		this.pageNavigation = this.pageNavigation.bind(this);
		this.autoSort = this.autoSort.bind(this);
	}

	componentDidMount() {
		Glob.setStatus('pageTitle', ["Administration",prefix]);
		Glob.setStatus('pageIcon', <AppAdminIcon/>);
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('userPrefs', ()=>{
			const ll = Glob.getLanguageLong();
			if ( ll !== this.state.ll ) this.setState({ ll: ll }, this.fetchUsers );
		}, this.uid)
		setTimeout(this.fetchLogs);
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	pageNavigation() {
		const maxPages = this.state.pages;
		if ( ! maxPages || maxPages < 2 ) return null;
		const cp = parseInt(this.state.page);
		const out = [];
		for ( let p = 1; p <= maxPages; p++ ) out.push(p);
		return (
			<div className="pageNavigation">
				{ out.map( p => (
					<div
						key={ p }
						className={ p === cp ? "current" : "active" }
						onClick={ ()=>{
							if ( p !== cp ) Glob.setCurrentPageParam('page', p);
						}}
					>
						{ p }
					</div>
				)) }
			</div>
		)
	}

	fetchLogs() {
		if ( this.state.resortTimeout ) try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
		this.setState({ loading: true, resortTimeout: false }, async () => {
			const filters = {}
			if ( this.state.chosenModule ) filters.module = this.state.chosenModule;
			if ( this.state.chosenUser ) filters.username = this.state.chosenUser;
			if ( this.state.chosenSize ) filters.limit = this.state.chosenSize;
			const ns = {};
			/** @type Array<LogLine> */
			ns.list = (await appLib.api('log/get', { filters: filters }))?.log || [];
			const limitChanged =  ( this.state.limit !== this.state.previousLimit );
			if ( limitChanged || (! this.state.chosenUser && ! this.state.chosenModule)) {
				if ( limitChanged ) ns.previousLimit = this.state.limit;
				ns.moduleOptions = [];
				ns.usersOptions = [];
				ns.list.forEach( ll => {
					if ( ! ns.moduleOptions.includes( ll.module ) ) ns.moduleOptions.push( ll.module );
					if ( ! ns.usersOptions.includes( ll.username ) ) ns.usersOptions.push( ll.username );
				});
				ns.moduleOptions = ns.moduleOptions.map( v => ({label: v, value: v }));
				ns.usersOptions = ns.usersOptions.map( v => ({label: v, value: v }));
			}
			this.setState(ns, this.sort);
		});
	}

	autoSort( cp ) {
		if ( ! cp ) cp = Glob.getCurrentPage();
		const ns = {};
		if (cp.params.by !== this.state.by) ns.by = cp.params.by;
		if (cp.params.page !== this.state.page) ns.page = cp.params.page;
		if (cp.params.pageSize && parseInt(cp.params.pageSize) !== this.state.pageSize) ns.pageSize = parseInt(cp.params.pageSize);
		if (cp.params.filter !== this.state.filter) ns.filter = cp.params.filter;
		if ( this.state.resortTimeout ) {
			try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
			ns.resortTimeout = false;
		}
		this.setState(ns, this.sort);
	}

	sortBy(axle) {
		//if ( axle === 'timestamp') axle = undefined;
		if ( axle === this.state.by ) return;
		if ( axle ) {
			Glob.setCurrentPageParam('by', axle);
		} else {
			Glob.rmCurrentPageParam('by' );
		} 
	}

	sort() {
		if ( this.state.resortTimeout ) try { clearTimeout(this.state.resortTimeout); } catch ( e ) {}
		const by = this.state.by || '';
		const currentPage = Number(this.state.page ?? 1);
		let page = currentPage;
		/** @type Array<LogLine> */
		let range = structuredClone(this.state.list || []);
		const pages = Math.ceil(range.length / this.state.pageSize);
		range.sort((a, b) => b.logtime - a.logtime);
		switch (by) {
			case 'severity':
				range.sort((a, b) => b.severity - a.severity);
				break;
			case 'content':
				range.sort((a, b) => (a.message && b.message) ? a.message.localeCompare(b.message) : -1);
				break;
			case 'user':
				range.sort((a, b) => a.username.localeCompare(b.username));
				break;
			case 'module':
				range.sort((a, b) => a.module.localeCompare(b.module));
				break;
			case 'param':
				range.sort((a, b) => a.param.localeCompare(b.param));
				break;
			default:
				break;
		}
		if ((page -1) * this.state.pageSize > range.length) page = 1;
		range = range.slice((page - 1) * this.state.pageSize, page * this.state.pageSize);
		this.setState(
			{
				range: range,
				by: by,
				page: String(page),
				pages: pages,
				loading: false,
			},
			() => {
				if (page !== currentPage) Glob.setCurrentPageParam('page', String(page));
			}
		);
	}

	render() {
		/*
			state:
			- list: the full list of users from server
			- range: the window of users to be shown
		 */
		if (!this.state.range) return null;
		const now = Date.now();
		return (
			<SliderPanel
				title={<TextLabel value={"LogView"}/>}
				icon={ <AppLogIcon /> }
				className={prefix}
			>
				<div className={"content limited"}>
					<div className={"control-buttons"}>
						<InputGroup>
							<InputGroupText>
								<ButtonGroup
									className="btn-icon"
								>
									<Button
										disabled={ !! this.state.loading }
										onClick={ this.fetchUsers }
										color={"primary"}
									>
										<b>
											<TextLabel value={"Reload"}/>
										</b>
										<i>
											<AppRefreshIcon />
										</i>
									</Button>
								</ButtonGroup>
							</InputGroupText>
						</InputGroup>
						<div className={"selects"}>
							<div>
								<div hidden={ this.state.usersOptions.length < 2 }>
									<TextLabel value={"Filter by user"} />
								</div>
								<div hidden={ this.state.moduleOptions.length < 2 }>
									<TextLabel value={"Filter by module"} />
								</div>
								<div className={"short"}>
									<TextLabel value={"Lines"} />
								</div>
							</div>
							<div>
								<div hidden={ this.state.usersOptions.length < 2 }>
									<Select
										placeholder={ Glob.label("Select") }
										isClearable={true}
										value={ (this.state.usersOptions||[]).find(o => o?.value === this.state.chosenUser) || null }
										onChange={e =>  this.setState({ chosenUser: e?.value || null }, this.fetchLogs) }
										options={this.state.usersOptions}
									/>
								</div>
								<div hidden={ this.state.moduleOptions.length < 2 }>
									<Select
										placeholder={ Glob.label("Select") }
										isClearable={true}
										value={ (this.state.moduleOptions||[]).find(o => o?.value === this.state.chosenModule) || null }
										onChange={e =>  this.setState({ chosenModule: e?.value || null }, this.fetchLogs) }
										options={this.state.moduleOptions}
									/>
								</div>
								<div className={"short"}>
									<Select
										placeholder={ Glob.label("Select") }
										value={ (this.state.sizeOptions||[]).find(o => o?.value === this.state.chosenSize) || null }
										onChange={e =>  this.setState({ chosenSize: e?.value || null }, this.fetchLogs) }
										options={this.state.sizeOptions}
									/>
								</div>
							</div>
							</div>
					</div>
					{(this.state.range.length > 0) && (
						<div className={"table-container"}>
							{ this.pageNavigation() }
							<table className={"log-list"} cellSpacing={0} cellPadding={0} border={0}>
								<thead>
								<tr>
									<th
										role={"button"}
										onClick={() => { this.sortBy('timestamp') }}
										className={this.state.by === 'timestamp' ? 'active' : 'inactive'}
									>
										<span>
											<TextLabel value={"Timestamp"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('severity') }}
										className={this.state.by === 'severity' ? 'active' : 'inactive'}
									>
										<span>
											<TextLabel value={"Severity"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('content') }}
										className={this.state.by === 'content' ? 'active' : 'inactive'}
									>
										<span>
											<TextLabel value={"Content"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('module') }}
										className={this.state.by === 'module' ? 'active' : 'no-mobile'}
									>
										<span>
											<TextLabel value={"Module"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('user') }}
										className={this.state.by === 'user' ? 'active' : 'inactive'}
									>
										<span>
											<TextLabel value={"User"}/>
										</span>
									</th>
									<th
										role={"button"}
										onClick={() => { this.sortBy('param') }}
										className={this.state.by === 'param' ? 'active' : 'no-mobile'}
									>
										<span>
											<TextLabel value={"Param"}/>
										</span>
									</th>
								</tr>
								</thead>
								<tbody>
								{ this.state.range.map( (log) => (
									<tr key={log.logtime}
										onClick={ ()=>{ this.setState({logInfo: log }) }}>
										<td className={"time"}>
											<div>
												{
													(now - log.logtime < 20000) ?
														<TextLabel value={"Now"} /> :
														(new Date(log.logtime)).toLocaleString(this.state.ll)
												}
											</div>
										</td>
										<td className={"severity"}>
											<div>
												{ this.state.severityMap[log.severity] }
											</div>
										</td>
										<td className={"content"} title={ log.message }>
											<div>
												{ log.message }
											</div>
										</td>
										<td className={"module no-mobile"} title={ log.module }>
											<div>
												{ log.module.split('.').pop() }
											</div>
										</td>
										<td title={ log.username }>
											{ log.username.split(/@/)[0] }
										</td>
										<td className={"param no-mobile"} title={ log.param }>
											<div>
												{ log.param }
											</div>
										</td>
									</tr>
								))}
								</tbody>
							</table>
							{ (!! this.state.logInfo) && (
								<LogInfoModal
									log={ this.state.logInfo }
									close={ ()=>{ this.setState({logInfo: null}) }}
								/>
							)}
						</div>
					)}
				</div>
			</SliderPanel>
		)
	}
}

export default UsersManagement;
